// extracted by mini-css-extract-plugin
module.exports = {"workItemList":"WorkItemList_workItemList__RRxfS","workItemList_select":"WorkItemList_workItemList_select__Lpbtg"};